export const HIDE_CONTENT_TEST_ID = "hide-content";
